import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import "./styles/navBar.css";

const NavBar = (props) => {
  const { active } = props;

  useEffect(() => {
    const handleScroll = () => {
      const nav = document.querySelector(".nav-background");
      if (window.pageYOffset > 0) {
        nav.classList.add("nav-scrolled");
      } else {
        nav.classList.remove("nav-scrolled");
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup function to remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <React.Fragment>
      <div className="nav-container">
        <nav className="navbar">
          <div className="nav-background">
            <ul className="nav-list">
              <li
                className={active === "home" ? "nav-item active" : "nav-item"}
              >
                <Link to="/" style={{ fontFamily: "Arial, sans-serif" }}>
                  Home
                </Link>
              </li>
              {/* <li
                className={active === "about" ? "nav-item active" : "nav-item"}
              >
                <Link to="/about" style={{ fontFamily: "Arial, sans-serif" }}>
                  About
                </Link>
              </li> */}
              <li
                className={
                  active === "projects" ? "nav-item active" : "nav-item"
                }
              >
                <Link
                  to="/projects"
                  style={{ fontFamily: "Arial, sans-serif" }}
                >
                  Projects
                </Link>
              </li>

              <li
                className={
                  active === "contact" ? "nav-item active" : "nav-item"
                }
              >
                <Link to="/contact" style={{ fontFamily: "Arial, sans-serif" }}>
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </React.Fragment>
  );
};

export default NavBar;
